import { API } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { toast } from "react-toastify";
import {
  createBulkSlotWarningQueryFn,
  createSlotWarningQueryFn,
  getSlotHistoryQueryFn,
} from "./slotHistoryQueries";

export const getSlotHistory = async (court_id: string, date: string) => {
  const { query, inputs, variables } = getSlotHistoryQueryFn(court_id, date);
  const myQuery = `
            query getSlotHistory(${inputs}) {
                 ${query}
            }
        `;
  try {
    const getSlotHistoryResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = getSlotHistoryResponse.data.getSlotHistory;
    if ("message" in response) {
      toast.error(response.message);
      throw new Error(response.message);
    }
    return response;
  } catch (error: any) {
    toast.error(error.errors[0].message);
    return false;
  }
};

export const createSlotWarning = async (
  datetime: string,
  court_id: string,
  comment: string,
) => {
  const { query, inputs, variables } = createSlotWarningQueryFn(
    datetime,
    court_id,
    comment,
  );
  const myQuery = `
            mutation createSlotWarning(${inputs}) {
                 ${query}
            }
        `;
  try {
    const createSlotWarningResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = createSlotWarningResponse.data.createSlotWarning;
    if ("message" in response) {
      toast.error(response.message);
      throw new Error(response.message);
    }
    return response;
  } catch (error: any) {
    console.log(error);
    toast.error(error.errors[0].message);
    return false;
  }
};

export const createBulkSlotWarning = async (input: {
  courts: string[];
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  comment: string;
}) => {
  const { query, inputs, variables } = createBulkSlotWarningQueryFn(
    input.courts,
    input.start_date,
    input.end_date,
    input.start_time,
    input.end_time,
    input.comment,
  );
  const myQuery = `
            mutation createBulkSlotWarnings(${inputs}) {
                  ${query}
            }
        `;
  try {
    const createBulkSlotWarningResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = createBulkSlotWarningResponse.data.createBulkSlotWarnings;
    if ("message" in response) {
      toast.error(response.message);
      throw new Error(response.message);
    }
    return response;
  } catch (error: any) {
    toast.error(error.errors[0].message);
    return false;
  }
};
